export const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/;

export const Name = {
    label: "Name",
    validation: {
      valid: "Name is required",
      required: "Name is required"
    },
};

export const Role = {
    label: "Role",
    validation: {
      valid: "Role is required",
      required: "Role is required"
    },
};

export const phoneNumberRegex = /^\d{10}$/;
export const CONTACT_NUMBER = {
    label: "Contact number",
    validation: {
      valid: "Please enter a valid 10-digit contact number.",
      required: "Contact number is required"
    },
};

export const EMAIL = {
  label: "Email",
  validation: {
    required: "Email is required",
    valid: "Please enter a valid email address.",
    invalidCaps: 'Email is invalid, please type in lowercase.',
  },
};

export const DOB = {
  label: "Date of Birth",
  validation: {
    valid: "Date must be in the format DD/MM/YYYY",
    required: "DOB is required"
  },
  regex: dateRegex,
};

export const LICENSE_NUMBER = {
    label: "LICENSE NUMBER",
    validation: {
      valid: "License number is required",
      required: "License number is required"
    },
};

export const SIGNATURE = {
    label: "SIGNATURE",
    validation: {
      valid: "Signature is required",
      required: "Signature is required"
    },
}

export const DAY = {
    label: "DAY",
    validation: {
      valid: "Day is required",
      required: "Day is required"
    },
}

export const AVAILABILITY = {
  label: "Availability",
  validation: {
    valid: "Availability is required",
    required: "Availability is required",
  },
};

export const MODALITY = {
  label: "Modality",
  validation: {
    valid: "Modality is required",
    required: "Modality is required",
  },
};

export const STUDY_REGIONS = {
  label: "Study Region",
  validation: {
    valid: "Study Region is required",
    required: "Study Region is required",
  },
};

export const FROM_TIME = {
    label: "FROM TIME",
    validation: { },
}

export const TO_TIME = {
    label: "TO TIME",
    validation: { },
}
